import(/* webpackMode: "eager", webpackExports: ["DeferredWebVitals"] */ "/vercel/path0/app/_components/DeferredWebVitals.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/GlobalMemoryMonitorWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/VersionLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"utils/fonts.ts\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-playfair-display\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"playfairDisplay\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/providers/Providers.tsx");
